import React, { useEffect, useState } from 'react';
import AdModal from '../Modals/AdModal';
import getAds from '../../../ApiV2/getAds.jsx';
import { useLocation } from 'react-router';
import postViewedItem from '../../../ApiV2/postViewedItem';
import { TIME_TO_SWITCH_ADS_5SEC, TIME_TO_SWITCH_ADS_10SEC } from '../../../Constants/Constants';


let ImageSlider = () => {

  const [index, setIndex] = useState(0);
  const [modalVisiblity, setmodalVisiblity] = useState(false);
  const [adBannerImages, setAdBannerImages] = useState([]);

  var location = useLocation();
  location = location.pathname.split('/')[2];

  useEffect(() => {
    console.log(location)
    if (location !== undefined) {
      getAds(location)
        .then(response => {
          response.json().then(data => ({
            data: data,
            status: response.status
          }))
            .then(jsonResponse => {

              setAdBannerImages(jsonResponse.data);
              console.log(jsonResponse.data)
            })
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }, [])

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (modalVisiblity === false) {

        if (index >= adBannerImages.length - 1) {
          setIndex(0);
        }
        else {
          setIndex(index + 1)
        }
      }
    }, TIME_TO_SWITCH_ADS_10SEC)

    return () => clearInterval(intervalId);
  }, [index, adBannerImages, modalVisiblity])

  const displayAd = (adGuid) => {
    if (modalVisiblity === true) {
    }

    var parameters = {
      AdGuid: adGuid,
      LocationGuid: location,
    }

    postViewedItem(parameters);
    setmodalVisiblity(!modalVisiblity);
  }

  return (
    <>
      {modalVisiblity ? (<AdModal imageSource={adBannerImages[index]?.adImagePath}
        adGuid={adBannerImages[index]?.adGuid}
        setClick={() => setmodalVisiblity(false)} />) 
        : null}

      {adBannerImages.length > 0 ?
        (
          <div className="slider-wrapper" onClick={() => { displayAd(adBannerImages[index]?.adGuid) }}>
            <div className="ad-image-left">
              <img src={adBannerImages[index]?.adImagePath} alt="ad banner" />
            </div>
            <div className="slider-content">
              <div className="sponsor-section">
                <div className="sponsor-text">Thank you to our sponsors. Tap a name/image to learn more.</div>
              </div>
              <div className="adText">{adBannerImages[index]?.bannerText}</div> 
            </div>
          </div>)
        : <></>
      }
    </>
  );

}


export default ImageSlider;